const FEEDBACK_MESSAGES = {
	SUCCESS: "Salvo com sucesso!",
	ERROR: "Erro ao salvar!"
};


export default FEEDBACK_MESSAGES;